<template>
    <div id="myAccount" class="myAccount">
        <div class="myAccount-content">
            <div class="myAccount-content-left">
                <div class="content-grid left-top">
                    <div class="img-wrapper">
                        <img class="imgone" :src="`${$baseUrl}dataMock/devCenter/account-top.png`" />
                    </div>
                    <div class="title-line">
                        <div class="dotline"></div>
                    </div>
                    <div class="content-container">
                        <div class="content-name">
                            <span class="content-left">账户名称：</span>
                            <span class="content-right" style="color: #0c78e2;">{{ displayName }}</span>
                        </div>

                        <div class="content-name">
                            <span class="content-left">邮箱：</span>
                            <span class="content-right" style="color: #0c78e2;">{{ email }}</span>
                        </div>

                        <div class="content-name">
                            <span class="content-left">手机号码：</span>
                            <span class="content-right" style="color: #0c78e2;">{{ phoneNumber }}</span>
                            <el-button
                                v-if="!phoneNumberValidated"
                                @click="isValidatePhone = true"
                                type="primary"
                                size="mini"
                                >验证手机</el-button
                            >
                        </div>

                        <div class="content-name">
                            <span class="content-left">创建时间：</span>
                            <span class="content-right">{{ createAt }}</span>
                        </div>
                    </div>
                    <div class="content-tips-container">
                        <!-- <button class="content-tip" @click="contactUs"> 收费细则</button> -->
                    </div>
                </div>
                <div class="content-grid left-middle">
                    <div v-if="!firstApp" class="content-container mid-content">
                        <div class="content-name">
                            <span class="content-left">离到期日还：</span>
                        </div>
                        <div class="content-name leftTime-mid">
                            <span class="content-left leftTime-day" :class="accountStatus">{{ leftTime }}</span>
                            <span class="content-left leftTime-unit">{{ leftUnit }}</span>
                        </div>
                        <div class="title-line">
                            <div class="dotline"></div>
                        </div>
                        <div class="content-name leftTime-bottom">
                            <div class="userType-img-wrapper">
                                <span class="content-left">应用性质：</span>
                                <img
                                    v-if="userType === 'trial'"
                                    class="imgone"
                                    :src="`${$baseUrl}dataMock/devCenter/trial-version.png`"
                                />
                                <img
                                    v-if="userType === 'commercial'"
                                    class="imgone"
                                    :src="`${$baseUrl}dataMock/devCenter/pro-version.png`"
                                />
                            </div>
                        </div>
                        <div class="content-name leftTime-bottom">
                            <span class="content-left">试用到期日：</span>
                            <span class="content-right">{{ leftDate }}</span>
                        </div>
                    </div>

                    <div v-if="firstApp" class="content-container firstApp">
                        <button class="create-btn" @click.prevent="ceatApp">
                            创建应用
                        </button>
                    </div>

                    <div class="content-tips-container">
                        <button class="content-tip" :class="accountStatus" @click="contactUs">
                            我要延期
                        </button>
                    </div>
                </div>
                <div class="content-grid left-bottom">
                    <div class="content-container" style="min-height: 220px;">
                        <accountStorageChart ref="storageChart" :chartData="storageChartData" />
                        <div class="content-name stoarge-bottom">
                            <span class="content-left">空间限制：</span>
                            <span class="content-right">{{ storageLimit }}</span>
                        </div>
                    </div>
                    <div class="content-tips-container">
                        <button class="content-tip" @click="contactUs">更多空间</button>
                    </div>
                </div>
            </div>
        </div>
        <contactUsCom @send-message="sendMessage" ref="contactUsCom"></contactUsCom>

        <el-dialog
            title=""
            :visible.sync="isValidatePhone"
            width="420px"
            :close-on-click-modal="false"
            :before-close="() => beforeClose()"
        >
            <div class="validate-phone">
                <div v-if="isPhoneError" class="phone-error">
                    {{ phoneErrorMessage }}
                </div>
                <span class="title">手机号码：</span>
                <el-input
                    v-model="phoneValidated"
                    @input="handlePhoneChange"
                    class="phone-input"
                    size="mini"
                    placeholder="请输入手机号码"
                ></el-input>
            </div>
            <div class="validate-phone" style="margin-top: 20px;">
                <span class="title">验证码：</span>
                <el-input v-model="captcha" class="phone-input" size="mini" placeholder="请输入验证码"></el-input>
                <el-button v-if="!disablesCaptcha" @click="sendCaptcha" class="send-captcha" type="primary" size="mini"
                    >发送验证码</el-button
                >
                <el-button v-else :disabled="disablesCaptcha" class="send-captcha" type="primary" size="mini"
                    >{{ countdown }}s</el-button
                >
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="beforeClose">取 消</el-button>
                <el-button
                    :disabled="bindPhoneLoading"
                    :loading="bindPhoneLoading"
                    size="mini"
                    type="primary"
                    @click="bindPhone"
                    >确 定</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import accountStorageChart from 'src/pages/devCenter/consoleLab/myAccount/account-storage-chart';
import { getUserToken, getUserInfo, setUserType } from 'src/utils/loginUtils';
import { getAppInfo } from 'src/utils/appUtils';
import { getSpaceCapacity } from 'src/utils/calculateUtils';
import { formatTime, formatLeftTime } from 'src/utils/commonUtils';
import contactUsCom from '../components/contactUsCom';
import {
    bindPhoneRequest,
    sendCaptchaRequest,
    sendEmailToAccountUpgrade,
    sendDevopsTicket,
} from '../../../../utils/sendMessage';
import RuntimeUtils from 'src/common/js/runtimeUtils';
import { getObjectViewToken } from 'src/utils/modelUtils';

export default {
    name: 'myAccount',
    components: {
        accountStorageChart,
        contactUsCom,
    },
    data() {
        return {
            storageChartData: {
                id: 'storageChart',
                occupyColor: '#3FC3F4',
                emptyColor: '#86A9CC',
                textContent: 0,
                textColor: '#3FC3F4',
            },
            accountStatus: 'normal', // normal,urgent,deadline
            // 账户概览的信息
            firstApp: false,
            displayName: '',
            phoneNumber: null,
            email: null,
            userType: 'trial',
            createAt: '',
            leftTime: '',
            leftUnit: '',
            leftDate: '',
            storageLimit: 'G',
            phoneNumberValidated: false,
            isValidatePhone: false,
            isPhoneError: false,
            phoneErrorMessage: '',
            phoneValidated: '',
            disablesCaptcha: false,
            countdown: 60,
            sendCaptchaTimer: 0,
            captcha: '',
            bindPhoneLoading: false,
            clientId: '',
            company: '',
        };
    },
    methods: {
        sendMessage(text) {
            // if (this.hasValidateBindPhone()) {
            //     return;
            // }
            if (!text) {
                this.$message.warning('联系内容不为空！');
                return;
            }
            const ticketAgrs = {
                environment: RuntimeUtils.instance.getSendEmailHostname(),
                content: text,
                expectation: formatTime(new Date()),
                describes: `用户姓名*：${this.displayName}，ClientID：${this.clientId}，创建时间：${this.createAt}, 单位*：${this.company}，手机号码：${this.phoneNumber}，邮箱：${this.email}`,
            };
            text = `当前环境域名-${RuntimeUtils.instance.getSendEmailHostname()}，${text}`;

            // todo 后台接口限制 每10分钟 才能发一次
            sendEmailToAccountUpgrade(text)
                .then(() => {
                    this.$refs.contactUsCom.close();
                    this.$message.success('发送邮件成功！');
                    this.sendDevopsTickets(ticketAgrs);
                })
                .catch((e) => {
                    let error = '';
                    if (e && e.responseText.indexOf('请求太频繁了，休息一会吧。') !== -1) {
                        error = '请求太频繁了，休息一会吧。';
                    }
                    this.$message.error(`发送失败！请重试${error}`);
                });
        },
        sendDevopsTickets(ticketAgrs) {
            getObjectViewToken().then((res) => {
                sendDevopsTicket(ticketAgrs, res.data.newToken).then(() => {
                    console.log('工单发送成功！');
                });
            });
        },
        hasValidateBindPhone() {
            if (!this.phoneNumberValidated) {
                this.isValidatePhone = true;
            }
            return !this.phoneNumberValidated;
        },
        beforeClose() {
            this.phoneNumberValidated = false;
            this.isValidatePhone = false;
            this.isPhoneError = false;
            this.phoneErrorMessage = '';
            this.phoneValidated = '';
            this.disablesCaptcha = false;
            this.countdown = 60;
            this.sendCaptchaTimer = 0;
            this.captcha = '';
            this.bindPhoneLoading = false;
        },
        sendCaptcha() {
            if (this.sendCaptchaTimer) {
                clearInterval(this.sendCaptchaTimer);
            }
            sendCaptchaRequest(this.phoneValidated)
                .then(() => {
                    this.$message.success('验证码发送成功！');
                    this.handleCountdown();
                })
                .catch((err) => {
                    if (err.status === 400) {
                        this.$message({
                            type: 'warning',
                            message: '验证码发送冷却时间未到',
                        });
                        this.disablesCaptcha = true;
                        return;
                    }
                    this.disablesCaptcha = false;
                    this.$message.error('验证码发送失败！请重试');
                });
        },
        handleCountdown() {
            this.disablesCaptcha = true;
            if (this.sendCaptchaTimer) {
                clearInterval(this.sendCaptchaTimer);
            }
            this.countdown = 60;
            this.sendCaptchaTimer = setInterval(() => {
                --this.countdown;
                if (this.countdown <= 0) {
                    clearInterval(this.sendCaptchaTimer);
                    this.sendCaptchaTime = 0;
                    this.disablesCaptcha = false;
                }
            }, 1000);
        },
        bindPhone() {
            if (!this.phoneValidated || !this.captcha) {
                this.$message.error('请先填写手机号码和验证码！');
                return;
            }
            this.bindPhoneLoading = true;
            bindPhoneRequest(this.phoneValidated, this.captcha)
                .then(async () => {
                    await this.getUserInfo();
                    this.isValidatePhone = false;
                    this.bindPhoneLoading = false;
                    this.$message.success('手机号码绑定成功！');
                })
                .catch((e) => {
                    let error = '';
                    if (e && e.responseText && e.responseText.indexOf('手机号码已存在') !== -1) {
                        error = '手机号码已存在!';
                    }
                    // if (e && e.response && e.response.data) {
                    //     error = e.response.data.message;
                    // }
                    this.$message.error(`绑定手机失败！ ${error}`);
                    this.bindPhoneLoading = false;
                });
        },
        initPage() {
            this.getAppInfo();
            this.getSpaceCapacity();
        },
        getUserInfo() {
            getUserInfo().then((accountRes) => {
                this.initPage();
                this.displayName = accountRes.displayName;
                this.phoneNumber = accountRes.phoneNumber;
                this.email = accountRes.email;
                this.phoneNumberValidated = accountRes.phoneNumberValidated;
                this.company = accountRes.company;
                this.createAt = formatTime(accountRes.createAt);
            });
        },
        getAppInfo() {
            getAppInfo().then((appRes) => {
                // 判断是否是第一次使用app
                if (appRes.items.length !== 0) {
                    this.clientId = appRes.items[0].clientId;
                    const leftTimeData = formatLeftTime(appRes.items[0].expireIn);
                    this.leftTime = leftTimeData.leftTime;
                    this.leftUnit = leftTimeData.leftUnit;
                    // 到期时间
                    this.leftDate = formatTime(appRes.items[0].expireIn);
                    // 账户状态
                    this.userType = appRes.items[0].type;
                    setUserType(appRes.items[0].type);
                    // 不同的状态
                    if (leftTimeData.leftTime < 0) {
                        this.accountStatus = 'overline';
                        this.leftTime = '已过期';
                        this.leftUnit = '';
                    } else if (leftTimeData.leftTime <= 10 || leftTimeData.leftUnit === '小时') {
                        this.accountStatus = 'deadline';
                    } else if (leftTimeData.leftTime <= 30) {
                        this.accountStatus = 'urgent';
                    }
                } else {
                    this.firstApp = true;
                }
            });
        },
        getSpaceCapacity() {
            getSpaceCapacity().then((accountRes) => {
                // 容量返回值是 -1 代表无限制，个别是 1G 和 5G
                if (accountRes) {
                    if (accountRes.data.capacity === -1) {
                        this.storageLimit = `无限制容量`;
                        this.storageChartData.textContent = 0;
                    } else {
                        this.storageLimit = `${accountRes.data.capacity / 1024 / 1024 / 1024}G`;
                        this.storageChartData.textContent = (
                            (accountRes.data.usedCapacity / accountRes.data.capacity) *
                            100
                        ).toFixed(1);
                    }
                }
            });
        },
        contactUs() {
            this.$refs.contactUsCom.Open();
        },
        ceatApp() {
            // if (this.hasValidateBindPhone()) {
            //     this.$message.warning('请先绑定手机号码');
            //     return;
            // }
            this.$router.push('/devcenter/console/myapp');
        },
        handlePhoneChange(value) {
            if (!this.isPhone(value)) {
                this.phoneErrorMessage = '手机号码格式错误';
                this.isPhoneError = true;
            } else {
                this.phoneErrorMessage = '';
                this.isPhoneError = false;
            }
        },
        isPhone(phone) {
            if (!/^1[3456789]\d{9}$/.test(phone)) {
                return false;
            }
            return true;
        },
    },
    mounted() {
        // 获取账户信息
        this.getUserInfo();
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~common/stylus/variable'
  @import '~common/stylus/mixin'
.myAccount
  width 88%
  background-color $background-darkwhite
  .myAccount-content
    width 100%
    height calc(100% - 75px)
    padding-top 20px
    display flex
    justify-content: space-evenly
    .myAccount-content-left
      width 97%
      height 55%
      display flex
      flex-direction row
      justify-content flex-start
      .img-wrapper
        display flex
        align-items: center;
        justify-content: center;
        padding 20px
        width 100%
        img
          max-width 370px
          max-height 180px
          width:100%
          height:100%
      .title-line
        dom_center()
        width 100%
        .dotline
          height 1px
          width 85%
          background-color $background-lightgrey
          z-index 1
      .content-container
        display flex
        flex-direction: column
        justify-content: space-evenly
        height: 55%
        min-height 142px
        .content-name
          margin-left: 10%
          .content-left
            font-size 14px
            color $font-console
          .content-right
            font-size 14px
            padding-left: 1%
            color $font-itemTitle
          .userType-img-wrapper
            display flex
            align-items: center;
            justify-content: flex-start;
            img
              max-width 72px
              max-height 28px
              width:100%
              height:100%
      .content-grid
        width 22%
        height 100%
        min-width 260px
        min-height 280px
        display flex
        flex-direction column
        justify-content space-between
      .content-container.mid-content
        height 90%
        justify-content: flex-start
        padding: 20px 0px
      .content-container.firstApp
        dom_center()
        .create-btn
          width: 160px
          height: 50px
          background: #3FC3F4
          border: 1px solid #3FC3F4
          border-radius: 25px
          font-size: 20px;
          font-weight bold
          line-height: 20px
          outline: none
      .left-top
        background-color $background-white
        .img-wrapper
          display flex
          align-items: center;
          justify-content: center;
          padding 20px
          width 100%
          height: 30%
          img
            max-width 57px
            max-height 50px
            width:100%
            height:100%
      .left-middle
        margin-left 2%
        background-color $background-white
        .content-name.leftTime-mid
          margin-left 0%
          display flex
          justify-content: center
          align-items: baseline
          padding 12% 0px
        .content-left.leftTime-day
          font-size: 70px;
          letter-spacing: 0;
          text-align: center;
          line-height: 70px;
          font-weight: bold;
        // 区分不同的状态
        .content-left.leftTime-day.normal
          color: #3FC3F4
        .content-left.leftTime-day.urgent
          color: #FFAA3E
        .content-left.leftTime-day.deadline
          color: #FF6F52
        .content-left.leftTime-day.overline
          color: #EE2C2C
        .content-left.leftTime-unit
          margin-left 2%
          font-family: PingFang-SC-Bold;
          font-size: 20px;
          color: #666666;
          line-height: 20px;
          font-weight: bold;
        .content-name.leftTime-bottom
          margin-top 10%
      .left-bottom
        margin-left 2%
        background-color $background-white
        .content-name.stoarge-bottom
          margin-top 5%
      .content-tips-container
        width 100%
        display flex
        justify-content flex-end
        // 区分不同的状态
        .content-tip.normal
          background-color #3FC3F4
        .content-tip.urgent
          background-color #FFAA3E
        .content-tip.deadline
          background-color #FF6F52
        .content-tip.overline
          background-color: #EE2C2C
        .content-tip
          width 84px
          height 30px
          margin-bottom 20px
          border-radius 62px 0px 0px 62px
          border 0px
          outline none
          background-color #3FC3F4
  .validate-phone {
    line-height 28px
    padding-left 23px
    .title {
      width 70px
      display inline-block
    }
    .phone-input {
      display inline-block
      width 180px
    }
    .send-captcha {
      display inline-block
      margin-left 5px
    }
    .phone-error {
      color #ff0000
      font-size 12px
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/myAccount/myAccount.vue